import CompanyOrganizationViewComponent from "../components/CompanyOrganizationView";
import useCompanyOrganization from "../hooks/useOrganization";

function CompanyOrganizationView(props) {
  const useCompanyOrganizationProps = useCompanyOrganization(props);
  return <CompanyOrganizationViewComponent {...useCompanyOrganizationProps} />;
}

export default CompanyOrganizationView;
